"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._global = exports.diStoreKey = exports.key = void 0;
function getKey() {
  return Symbol.for('__@@WHAT_DI_CONTAINER@@__');
}
exports.key = getKey();
exports.diStoreKey = Symbol.for('__@@EASY_DEPENDENCE_INJECTION_STORE@@__');
exports._global = typeof window !== "undefined" ? window : global;